import { render } from "./CoursesSalesChart.vue?vue&type=template&id=0ed10e30&ts=true"
import script from "./CoursesSalesChart.vue?vue&type=script&lang=ts"
export * from "./CoursesSalesChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__